<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Button from "@/components/button";
import Input from "@/components/c-input";
import Area from "@/components/c-input-area";
import Select from "@/components/c-select";
import { propertyService } from "../../../services/propertyservice/property.service";
import { propertycancelationService } from "../../../services/propertyservice/propertycancelation.service";
import { bookingService } from "../../../services/bookingservice/booking.service";
import { saleService } from "../../../services/saleservice/sale.service";
import i18n from "../../../i18n";
import Loader from "../../../components/widgets/loader";

/* eslint-disable no-console */
/**
 * Contacts-list component
 */
export default {
  page: {
    title: "Property Cancelation",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { 
    Layout, 
    PageHeader, 
    Loader, 
    Button,
    Input,
    Area,
    Select
  },
  data() {
    return {
      isAdd: true,
      fetchingStats: false,
      tryingToSubmit: false,
      title: "property",
      breadCrumb: {},
      propertyData: {},
      paymentMethodData: [],
      bankAccountData: [],
      user: JSON.parse(localStorage.getItem('user')),
      valueDate: this.$moment().clone().format('YYYY-MM-DD'),
      valueProperty: '',
      valueSale: '',
      valueBooking: '',
      valueTotal: 0,
      valueDiscount: 0,
      valueBalance: 0,
      valueRefund: 0,
      valueNotation: '',
      valuePaymentMethod: 0,
      valueBankAccount: 0,
      valueBookingSaleDate: this.$moment().clone().format('YYYY-MM-DD'),
    };
      
  },
  mounted() {
    
    let hasId = 'id' in this.$route.params;
    this.isAdd = this.fetchingStats = !hasId;
    if(hasId) {
      this.loadingData(this.$route.params.id);    
    } else if('saleid' in this.$route.query) {
      this.loadingSaleById(this.$route.query.saleid);
    } else if('bookingid' in this.$route.query) {
      this.loadingBookingById(this.$route.query.bookingid); 
    } else {
      this.loadingData(0);     
    }

  },

  methods: {
    loadingData: function(id) {
      // console.log("AAAAAA", id);
      this.fetchingStats = false;
      propertyService.getSaleAndBookingByProperty(id)
        .then(response => {
          if(response.data) {
            this.breadCrumb = {
              text: response.data.code,
              active: true,
            };

            this.fetchingStats = true;
            this.loading(response);

          }

          this.loadingSettings(response.setting);
          
        });
    },

    loadingSettings: function(setting) {

      this.paymentMethodData = {data: setting.paymentmethods};
      this.bankAccountData = {data: setting.bankaccounts};
    },

    loadingBookingById: function(id) {

      this.fetchingStats = false;
      bookingService.getBookingByProperty(id)
        .then(response => {

          if(response.data) {
            this.breadCrumb = {
              text: response.data.code,
              active: true,
            };
            
            this.fetchingStats = true;
            this.loading(response);
          }

          this.loadingSettings(response.setting);

        });
    },

    loadingSaleById: function(id) {

      this.fetchingStats = false;
      saleService.getSaleByProperty(id)
        .then(response => {

          if(response.data) {
            this.breadCrumb = {
              text: response.data.code,
              active: true,
            };
            
            this.fetchingStats = true;
            this.loading(response);
            

          }

          this.loadingSettings(response.setting);
        });
    },

    loading: function(response) {
      this.propertyData = response;
      this.valueProperty = this.propertyData.data.code;
      this.valueSale = this.propertyData.data.sale;
      this.valueBooking = this.propertyData.data.booking;
      this.valueTotal = this.propertyData.data.total_paid;
      this.valueBookingSaleDate = this.propertyData.data.sale_date != "" ? this.propertyData.data.sale_date : 
                                          this.propertyData.data.booking_date != "" ? this.propertyData.data.booking_date :
                                          null;

      this.valueDiscount = this.propertyData.data.voucher_discount;
      this.valueBalance = this.valueTotal - this.valueDiscount;
      this.valueRefund = 0;
      this.valueNotation = '';
    },

    submitCancel: function() {

      this.$swal.fire({
        title: i18n.t('general.cancel-confirm.title'),
        text: i18n.t('general.cancel-confirm.message'),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: i18n.t('general.cancel-confirm.yes'),
        cancelButtonText: i18n.t('general.cancel')
      }).then(result => {
        if (result.value) {

          this.$router.push(this.$route.query.redirectFrom || {
              name: "property-list"
          });

        }
      });

      
    },

    submitSave: function() {

      // console.log(this.valueRefund, this.propertyData.data.total_paid);

      if(this.valueRefund > (this.propertyData.data.total_paid - this.propertyData.data.voucher_discount)) {
        this.$swal.fire({
          title: i18n.t('property.cancelation.refund'),
          text: i18n.t('property.cancelation.warnning-message'),
          icon: "error",
          confirmButtonColor: "#34c38f",
          confirmButtonText: i18n.t('general.success.yes')
        });
        return;

      } else if(this.valuePaymentMethod == 0) {
        this.$swal.fire({
          title: i18n.t('property.cancelation.refund'),
          text: i18n.t('property.cancelation.warnning-message'),
          icon: "error",
          confirmButtonColor: "#34c38f",
          confirmButtonText: i18n.t('general.success.yes')
        });
        return;
      }

      this.tryingToSubmit = true;

      let obj = {
        for_date: this.valueDate,
        booking_sell_date: this.valueBookingSaleDate,
        property_id: this.propertyData.data.id,
        sale_id: this.propertyData.data.sale_id,
        booking_id: this.propertyData.data.booking_id,
        total: this.propertyData.data.total_paid,
        refund_amount: this.valueRefund,
        notation: this.valueNotation,
        user_id: this.user.id,
        property_cancelation_status_id: 1,
        approve_user_id: this.user.id,
        payment_method_id: this.valuePaymentMethod,
        bank_account_id: this.valueBankAccount
      };

      // console.log(JSON.stringify(obj));
      propertycancelationService.insert(obj)
        .then(response => {
        this.tryingToSubmit = false;

        if(response.status == 200) {
          this.$router.push(this.$route.query.redirectFrom || {
            name: "property-list"
          });

          this.$swal.fire({
            title: i18n.t('general.success.title'),
            text: i18n.t('general.success.message-edit'),
            icon: "success",
            confirmButtonText: i18n.t('general.ok')
          });

        }
      });

      
    },

    clearForm: function() {
      this.valueDate = this.$moment().clone().format('YYYY-MM-DD'),
      this.valueProperty = '';
      this.valueSale = '';
      this.valueBooking = '';
      this.valueTotal = 0;
      this.valueRefund = 0;
      this.valueNotation = "";
    },

    paymentMethodChanged: function(event) {

      if(event != 2 && event != 3) {
        this.valueBankAccount = 0;
      }
    },
  }
};
</script>

<template>
  <Layout>

    <PageHeader :items="[{
      text: $t('property.text'),
      href: '/general/property',
    }, this.breadCrumb]" :title="$t('property.cancelation.text') + ' ' + $t('property.text')" />

    
    <Loader :loading="fetchingStats">
    <div class="row">
      <b-form class="row">
        <div class="col-lg-8">
          <div class="card">
            <div class="card-body">
              
              <div class="row">
                <div class="col-md-6">
                  <Input 
                    :type="'date'"
                    :id="'for_date'"
                    v-model="valueDate"
                    :label="'property.cancelation.date'" 
                  /> 
                </div>
                <div class="col-md-6">
                  <Input 
                    :type="'text'"
                    :id="'property_id'"
                    v-model="valueProperty"
                    :disabled="true"
                    :label="'property.text'" 
                  /> 
                </div>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <Input 
                    :type="'text'"
                    :id="'booking_id'"
                    v-model="valueBooking"
                    :disabled="true"
                    :label="'property.cancelation.booking'" 
                  /> 
                </div>
                <div class="col-md-6">
                  <Input 
                    :type="'text'"
                    :id="'sale_id'"
                    v-model="valueSale"
                    :disabled="true"
                    :label="'property.cancelation.sale'" 
                  /> 
                </div>
              </div>
              <div class="row">
                <div class="col-md-3">
                  <Input 
                    :type="'number'"
                    :id="'total'"
                    v-model="valueTotal"
                    :last="'USD'"
                    :label="'property.cancelation.total'" 
                  /> 
                </div>
                <div class="col-md-3">
                  <Input 
                    :type="'number'"
                    :id="'total'"
                    :disabled="true"
                    v-model="valueDiscount"
                    :last="'USD'"
                    :label="'property.cancelation.discount'" 
                  /> 
                </div>
                <div class="col-md-3">
                  <Input 
                    :type="'number'"
                    :id="'total'"
                    :disabled="true"
                    v-model="valueBalance"
                    :last="'USD'"
                    :label="'property.cancelation.total-balance'" 
                  /> 
                </div>
                <div class="col-md-3">
                  <Input 
                    :type="'number'"
                    :id="'refund_amount'"
                    v-model="valueRefund"
                    :last="'USD'"
                    :label="'property.cancelation.refund'" 
                  /> 
                </div>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <Select
                    @change="paymentMethodChanged" 
                    :id="'payment_method_id'"
                    :auto="true"
                    v-model="valuePaymentMethod"
                    :list="this.paymentMethodData"
                    :label="'booking.payment-method'"
                     /> 
                </div>
                <div v-show="valuePaymentMethod == 2 || valuePaymentMethod == 3" class="col-md-6">
                  <Select
                    :id="'bank_account_id'"
                    v-model="valueBankAccount"
                    :list="this.bankAccountData"
                    :label="'payment.bank_account'"
                     /> 
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <Area 
                    :rows="7"
                    :id="'block_note'"
                    v-model="valueNotation"
                    :label="'property.cancelation.notation'"  />
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <b-form inline class="row gy-2 gx-3 align-items-end">
                    <div class="col-sm-auto">
                      <Button v-bind:icon="'bx bx-x-circle'" 
                        v-bind:buttonType="'button'"
                        v-bind:variant="'danger'"
                        @click="submitCancel()"
                        v-bind:title="$t('general.cancel')"  />
                    </div>
                    <div class="col-sm-auto">
                      <Button v-bind:icon="'bx bx-save bx-tada'" 
                        v-bind:buttonType="'button'"
                        @click="submitSave()"
                        v-bind:requesting="tryingToSubmit"
                        v-bind:title="$t('general.save')"  />
                    </div>
                  </b-form>
                </div>
              </div>

            </div>
          </div>
        </div>

        
      </b-form>
    </div>    
    </Loader>
  </Layout>
</template>